"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeProgramForLog = sanitizeProgramForLog;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Strips thumbnail fields from a program/scene before logging to avoid
 * bloating log payloads with base64 or large URL strings.
 */
function sanitizeProgramForLog(scene) {
  var _scene$layers;
  if (!scene) return scene;
  return _objectSpread(_objectSpread({}, scene), {}, {
    style: scene.style ? _objectSpread(_objectSpread({}, scene.style), {}, {
      backgroundImage: undefined
    }) : scene.style,
    layers: (_scene$layers = scene.layers) === null || _scene$layers === void 0 ? void 0 : _scene$layers.map(function (l) {
      return _objectSpread(_objectSpread({}, l), {}, {
        source: l.source ? _objectSpread(_objectSpread({}, l.source), {}, {
          thumbnail: undefined,
          value: l.source.value ? _objectSpread(_objectSpread({}, l.source.value), {}, {
            url: undefined
          }) : l.source.value
        }) : l.source
      });
    })
  });
}